export function empty(str) {
    return str === undefined || str === null || str.trim().length === 0;
}
export function truncate(str, n = 40) {
    return str && str.length > n ? str.slice(0, n - 1) + '…' : str;
}
export function replaceAll(str, find, replace) {
    if (!str)
        return '';
    return str.replace(new RegExp(find, 'g'), replace);
}
export function normalizePhoneNumber(tel) {
    if (!tel)
        return '';
    return replaceAll(tel.replace('(0)', ''), ' ', '');
}
export function prettifyUrl(url) {
    if (!url)
        return '';
    return url.replace(/^http(s)?:\/\/(www.)?|^www./g, '');
}
export function isEmailValid(email) {
    if (!email?.length)
        return false;
    return !!email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
export function escapeRegExp(string) {
    return string ? string.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&') : string;
}
export function formatFileSize(fileSize) {
    let size = parseInt(fileSize);
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `, ${size.toFixed(2)} ${units[unitIndex]}`;
}
//# sourceMappingURL=string.js.map